/** Constantes de jeu partagées par les systèmes du coeur. */

/** Demi-ouverture (en degrés) du cône d'aim assist autour de la direction visée. */
export const AIM_ASSIST_CONE_DEG = 12;
/** Distance maximale (px) à laquelle l'aim assist recale la visée sur un monstre. */
export const AIM_ASSIST_RANGE = 700;
/** Distance maximale (px) de la visée automatique quand il n'y a pas de pointeur (mobile). */
export const AUTO_AIM_RANGE = 900;
/** Hauteur du corps par défaut, en multiple du rayon (hitbox capsule). */
export const DEFAULT_BODY_HEIGHT_FACTOR = 2.2;
